<template>
  <v-btn
    dark
    :fixed="fixed"
    :absolute="absolute"
    small
    bottom
    :color="color"
    class="floating primary--text text--lighten-1"
    :customClass="customClass"
    :style="customStyle"
    @click="$emit('refresh')"
  >
    <v-icon class="material-symbols-rounded mr-2">{{ icon }}</v-icon>
    {{ text ? text : $t('actions.refresh') }}
  </v-btn>
</template>
<script>
export default {
  props: {
    icon: {
      default: 'change_circle',
    },
    customClass: {
      default: '',
    },
    text: {
      default: '',
    },
    color: {
      default: 'white',
    },
    fixed: {
      default: false,
    },
    absolute: {
      default: false,
    },
    customStyle: {
      default: '',
    },
  },
}
</script>